module.exports = __webpack_public_path__ + "images/drawings/moon/last-quarter.a70e914248ba8cf85ebe8ca2728739f2.png";